export default __webpack_public_path__ + "static/media/raven-solar-bg.3dff634b.jpeg";